module.exports = __webpack_public_path__ + "front/img/p2.b485bbef.png";